const Jimp = require("jimp");
// const alignImage = require("./utils/alignImage");
const calcMargin = require("./utils/calcMargin");

module.exports = function mergeImages(
  images,
  {
    color = 0x00000000,
    align = "start",
    offset = 0,
    isPng = false,
    margin,
    // 设置图片宽度
    dWidth = 0,
    // 设置图片高度
    dHeight = 0,
    // 横向最多显示多少个
    xCount = 3,
  } = {}
) {
  if (!Array.isArray(images)) {
    throw new TypeError("`images` must be an array that contains images");
  }

  if (images.length < 1) {
    throw new Error("At least `images` must contain more than one image");
  }

  const processImg = async (img) => {
    const imgBuffer = await new Buffer.from(img, "base64");
    return Jimp.read(imgBuffer).then((imgObj) => ({
      // 将图片缩放到固定的尺寸
      img: imgObj.scaleToFit(dWidth, dHeight),
    }));
  };

  return Promise.all(images.map(processImg)).then((imgs) => {
    const imgData = imgs.reduce(
      (res, { img, offsetX = 0, offsetY = 0 }, index) => {
        res.push({
          img,
          x: Number(index % xCount) * dWidth + offsetX + offset,
          y: Math.floor(index / xCount) * dHeight + offsetY + offset,
          offsetX,
          offsetY,
        });

        return res;
      },
      []
    );

    const { top, right, bottom, left } = calcMargin(margin);
    const marginTopBottom = top + bottom;
    const marginRightLeft = right + left;

    const imgLength = imgData.length;

    const totalWidth =
      Math.min(xCount, imgLength) * dWidth + (xCount - 1) * offset;

    const totalHeight =
      Math.ceil(imgLength / xCount) * dHeight +
      (Math.ceil(imgLength / xCount) - 1) * offset;

    const baseImage = new Jimp(
      totalWidth + marginRightLeft,
      totalHeight + marginTopBottom,
      color
    );

    // Fallback for `Array#entries()`
    const imgDataEntries = imgData.map((data, index) => [index, data]);
    for (const [, { img, x, y}] of imgDataEntries) {
      baseImage.composite(img, x + left, y + top);
    }

    return baseImage.getBase64Async(isPng ? Jimp.MIME_PNG : Jimp.MIME_JPEG);
  });
};
